import {
  defAlias,
  defBaseUnit,
  defCustomUnit,
  defSimpleUnit,
} from '../registry';

export const energyUnits = [
  // Energy
  defBaseUnit('joule', 'newton-meter'),
  defSimpleUnit('kilojoule', 'joule', 1e3),
  defSimpleUnit('megajoule', 'joule', 1e6),
  defSimpleUnit('gigajoule', 'joule', 1e9),
  defSimpleUnit('terajoule', 'joule', 1e12),
  defCustomUnit('watt-hour', 'watt-hour', 'joule', 3600),
  defCustomUnit('kilowatt-hour', 'kilowatt-hour', 'joule', 3.6e6),
  defCustomUnit('megawatt-hour', 'megawatt-hour', 'joule', 3.6e9),
  defCustomUnit('gigawatt-hour', 'gigawatt-hour', 'joule', 3.6e12),
  defCustomUnit('terawatt-hour', 'terawatt-hour', 'joule', 3.6e15),

  // US/UK customary units
  defSimpleUnit('british_thermal_unit', 'joule', 1055.05585262),
  defSimpleUnit('mmbtu', 'british_thermal_unit', 1e6),
  defSimpleUnit('kbtu', 'british_thermal_unit', 1e3),
  defSimpleUnit('therm', 'british_thermal_unit', 1e5),
];

defAlias('btu', 'british_thermal_unit');
defAlias('kWh', 'kilowatt-hour');
defAlias('kwh', 'kilowatt-hour');
defAlias('mWh', 'megawatt-hour');
defAlias('mwh', 'megawatt-hour');
defAlias('wh', 'watt-hour');
defAlias('mj', 'megajoule');
defAlias('MJ', 'megajoule');
defAlias('gj', 'gigajoule');
defAlias('GJ', 'gigajoule');
defAlias('tj', 'terajoule');
defAlias('TJ', 'terajoule');
